<form class="panel" (ngSubmit)="onSubmit()" [hidden]="hidden()" data-testid="wcg-create-entity-panel-study">
    @if ($referenceDataError()) {
        <p class="field__error" data-testid="wcg-create-entity-study-reference-data-error">Unable to load study statuses. Please refresh and try again.</p>
    }
    <h3 class="panel__section-title">Study Details</h3>
    <div class="field">
        <label class="field__label" for="wcg-study-name">Study Name<span class="field__required">*</span></label>
        <input id="wcg-study-name" class="field__input" type="text" placeholder="Enter study name" [formField]="$form.name" data-testid="wcg-create-entity-study-name" />
        @if ($form.name().invalid() && $form.name().touched()) {
            <span class="field__error">Study name is required.</span>
        }
    </div>
    <div class="field">
        <label class="field__label" for="wcg-study-label">Study Label</label>
        <input id="wcg-study-label" class="field__input" type="text" placeholder="Enter a display label" [formField]="$form.label" data-testid="wcg-create-entity-study-label" />
    </div>
    <div class="field">
        <label class="field__label" for="wcg-study-description">Study Description</label>
        <textarea
            id="wcg-study-description"
            class="field__input field__textarea"
            rows="3"
            placeholder="Enter a description"
            [formField]="$form.description"
            data-testid="wcg-create-entity-study-description"
        ></textarea>
    </div>
    <div class="field field--half">
        <label class="field__label" id="wcg-study-status-label">Study Status<span class="field__required">*</span></label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select aria-labelledby="wcg-study-status-label" placeholder="Select study status" [formField]="$form.status" data-testid="wcg-create-entity-study-status">
                @for (status of $studyStatuses(); track status.study_status_key) {
                    <mat-option [value]="status.study_status_key">{{ status.study_status_name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        @if ($form.status().invalid() && $form.status().touched()) {
            <span class="field__error">Study status is required.</span>
        }
    </div>
</form>
